module.exports = __webpack_public_path__ + "static/media/add.2594dbc7.svg";